<template>
  <div class="season_index">
    <page-header :title="$tc('season.name', 2)">
    </page-header>
    <page-content>
      <ntm-block :collapsable="false">
        <template slot="options">
<!--          <input type="text" class="form-control" :placeholder="$t('search')"  v-model="search">-->
          <button @click="createPage()" type="button" class="btn btn-sm btn-success">{{$t('action.addNew')}}</button>
        </template>
        <div class="table-responsive">
          <ntm-table :show-columns="showColumns" :data="model" @pageChange="setPage" :loading="loading">
            <template slot="actions" slot-scope="{row}">
              <router-link :to="{ name: 'seasons.edit', params: {uuid: row.uuid }}" class="btn btn-sm btn-primary" v-tooltip="$t('action.edit')">
                <i class="fa fa-pencil"></i>
              </router-link>
            </template>
          </ntm-table>
        </div>
      </ntm-block>
    </page-content>
  </div>
</template>
<script>
import SeasonService from '@/services/season.service'
import router from '@/router'
import basicIndexMixin from '@/mixins/basic.index.mixin'

export default {
  mixins: [basicIndexMixin],
  data () {
    return {
      showColumns: [
        {
          name: 'name',
          prop: 'name'
        }
      ]
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      SeasonService.index(this.page).then((response) => {
        this.setData(response.data)
      })
    },
    createPage () {
      router.push({ name: 'seasons.create' })
    }
  }
}
</script>
